import { useState, useEffect } from "react";
import { api } from "../../lib/api";
import { useImagePlacement } from "../../hooks/useImagePlacement";

export const About = () => {
  const [aboutText, setAboutText] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  const {
    imageUrls,
    isLoading: isImagesLoading,
    error: imagesError,
  } = useImagePlacement(5, {
    width: 150,
    height: 150,
    quality: 80,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const result = await api.getContentText("about", "main");
        if (result?.content) {
          setAboutText(result.content);
        }
      } catch (error) {
        console.error("Error in data fetching:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading || isImagesLoading) {
    return (
      <section id="about" className="py-20">
        <div className="container">
          <div className="flex items-center justify-center">
            <div className="w-4/6">
              <div className="border-2 border-gray-200 rounded-lg px-12 py-4 shadow-md animate-pulse">
                <div className="h-20 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (imagesError) {
    console.error("Error loading images:", imagesError);
  }

  return (
    <section id="about" className="py-20">
      <div className="container">
        <div className="flex items-center justify-center gap-1 md:gap-8">
          {/* 左側のイラスト */}
          <div className="w-1/6">
            {imageUrls[0] && (
              <img
                src={imageUrls[0]}
                alt="About Left"
                className="w-full h-auto object-contain"
              />
            )}
          </div>

          {/* 中央のテキストボックス */}
          <div className="w-4/6">
            <div className="border-2 border-gray-200 rounded-lg px-4 py-2 shadow-md">
              <p className="text-xs md:text-lg leading-relaxed text-gray-500 font-['Zen_Maru_Gothic']">
                {aboutText
                  .trim()
                  .split("\n")
                  .map((line, index) => (
                    <span key={index}>
                      {line.trim()}
                      {index < aboutText.trim().split("\n").length - 1 && (
                        <br />
                      )}
                    </span>
                  ))}
              </p>
            </div>
          </div>

          {/* 右側のイラスト */}
          <div className="w-1/6">
            {imageUrls[1] && (
              <img
                src={imageUrls[1]}
                alt="About Right"
                className="w-full h-auto object-contain"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
